export default {
	a_z: "A-Z",
	an_error_has_occurred_when_trying_to_redeem_the_item: "Une erreur s’est produite lors de la tentative d’utilisation de l’élément.",
	confirm_redeem: "Confirmer le rachat",
	confirm_redeeming_the_item: "Confirmer le rachat de l’élément",
	departments: "Départements",
	error_redeeming_item: "Erreur lors du rachat de l’élément",
	for: "pour",
	insuficient_points_for_redeem: "Points insuffisants pour échange",
	item_redeemed: "Article échangé",
	no_rewards_found: "aucune récompense trouvée",
	not_enough_items_in_stock: "Pas assez d’articles en stock",
	not_enough_points_to_redeem_item: "Pas assez de points pour procéder à un échange",
	our_team_will_be_in_touch_for_the_next_steps: "L'approbation est nécessaire. Veuillez attendre la confirmation. Merci.",
	popular: "Populaire",
	price_bigger_to_smaller: "Prix (du plus haut au plus bas)",
	price_smaller_to_bigger: "Prix(du plus bas au plus haut)",
	redeem_now: "Échanger maintenant ",
	result_plural: "résultats",
	result: "résultat",
	search_for_rewards_here_to_redeem_with_your_points: "Recherchez des récompenses ici pour les échanger avec vos points.",
	search_partners_or_offerings: "Rechercher des partenaires ou des offres",
	you_have_reached_the_max_number_of_redemptions_for_this_category: "Vous avez atteint la ponctuation maximale pour les rachats dans cette catégorie.",
	you_redeemed_successfully_the_item: "Vous avez requis à échanger l’élément: "
}